const windowListener = () => {
    const animatedIwtWrapper = document.querySelectorAll('.animated-iwt--wrapper');
    const lowerImageElement = document.querySelector('.animated-iwt--lower-image');
    if(window.innerWidth <= 1024) {
        animatedIwtWrapper.forEach(function(element) {
            if(!!element) {
                const bgImage = element.dataset.bgImage;
                const showBackgroundImage = element.dataset.showBackgroundImage == "true";
                element.style.backgroundImage =  bgImage?`url('${bgImage}')`:null;
                if(showBackgroundImage) {
                    lowerImageElement.style.display = "none";
                };
            };
        });
    } else {
        try {
            lowerImageElement.style.display = "block";
            animatedIwtWrapper.forEach(function(element) {
                if(!!element) {
                    const currentBackgroundImage = element.style.backgroundImage;
                    if(currentBackgroundImage.length > 0) {
                        element.style.backgroundImage = "";
                    };
                };
            });
        } catch(e) {}
    };
};

window.addEventListener("resize", windowListener);

windowListener();